import { createFileRoute } from '@tanstack/react-router';
import { fetchChatMessages, fetchChats } from '../../../../api/chats';

export const Route = createFileRoute('/_layout-app/app/chats/$chatId')({
  beforeLoad: async ({ params, context }) => {
    const { chatId } = params;

    // Prefetch the conversation data (messages + metadata)
    await context.queryClient?.prefetchQuery({
      queryKey: ['chat-messages', chatId],
      queryFn: () => fetchChatMessages(chatId),
      staleTime: 1000 * 60 * 2, // 2 minutes
    });

    // Also prefetch the conversations list if not already cached
    await context.queryClient?.prefetchQuery({
      queryKey: ['chats'],
      queryFn: async () => {
        return fetchChats();
      },
      staleTime: 1000 * 60 * 5, // 5 minutes
    });
  },
});
